<template>
  <app-layout title="Organisations">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <br />
      <!-- progress bar start from here -->

      <!-- progress bar start from here -->
      <upgrade-progressstep step="1"></upgrade-progressstep>
      <!-- progress end  -->
      <section>
        <div class="container mt-5">
          <div class="grid grid-cols-4 gap-4">
            <!-- left side end -->
            <div class="col-span-2">
              <h4 class="font-semibold mt-3">
                Why you should upgrade Unscreen Pro?
              </h4>
              <!-- starter plan start-->
              <div class="p-4 Starter">
                <h4 class="font-semibold">Starter</h4>
                <p>Yearly Subscription</p>
                <hr />
                <p class="tracking-widest font-semibold">PLAN BENEFIT</p>

                <ul class="my-3" style="list-style: none">
                  <li>
                    <i
                      class="fa fa-check"
                      style="color: rgb(74, 224, 174)"
                      aria-hidden="true"
                    ></i>
                    Free Domain for 1 year
                  </li>
                  <li>
                    <i
                      class="fa fa-check"
                      style="color: rgb(74, 224, 174)"
                      aria-hidden="true"
                    ></i>
                    $300 Ad Voucher
                  </li>
                  <li>
                    <i
                      class="fa fa-check"
                      style="color: rgb(74, 224, 174)"
                      aria-hidden="true"
                    ></i>
                    Form Builder App - $48 Value
                  </li>
                  <li>
                    <i
                      class="fa fa-check"
                      style="color: rgb(74, 224, 174)"
                      aria-hidden="true"
                    ></i>
                    Site Booster App - $60 Value
                  </li>
                </ul>

                <p class="tracking-widest font-semibold">PLAN FEATURES</p>
                <div class="my-3">
                  <p>Unlimited Bandwidth</p>
                  <p>Connect your Domain</p>
                  <p>Free Domain for 1 year</p>
                </div>
              </div>
              <!-- starter plan end -->
            </div>
            <!-- left side end -->

            <!-- right side start -->
            <div class="col-span-2 Plan_Card">
              <!-- Cards 1 start -->
              <label
                v-for="item in productData.rlt_cnslsubscriptionproduct_cnslproduct"
                :key="item.id"
                @click="getSelectedData(item.id)"
                :class="[
                  'card',
                  { 'opacity-50 cursor-not-allowed': item.isComSubActive },
                ]"
              >
                <!-- Disable the input if isComSubActive is true -->
                <input
                  name="plan"
                  class="radio"
                  type="radio"
                  v-model="selectedPlanId"
                  :value="item.id"
                  :disabled="item.isComSubActive"
                />

                <span class="text-left plan-details">
                  <div class="flex justify-between">
                    <div class="flex justify-start ml-4">
                      <h4 class="font-semibold">{{ item.name }}</h4>
                      <!-- <span
                        class="text-sm ml-2 mb-2 mt-1"
                        style="background-color: #d9d9d9"
                      >
                        Trial
                      </span> -->
                    </div>

                    <!-- Price based on frequency -->
                    <h4
                      v-if="
                        item.rlt_cnslproduct_cnslsubscriptionprice[0]
                          .frequency == 'Monthly'
                      "
                      class="font-semibold"
                    >
                      ₹
                      {{
                        item.rlt_cnslproduct_cnslsubscriptionprice[0]
                          .rlt_cnslsubscriptionprice_cnslsubscriptionpriceslab[0]
                          .price
                      }}
                      /mo
                    </h4>
                    <h4
                      v-if="
                        item.rlt_cnslproduct_cnslsubscriptionprice[0]
                          .frequency == 'Yearly'
                      "
                      class="font-semibold"
                    >
                      ₹
                      {{
                        item.rlt_cnslproduct_cnslsubscriptionprice[0]
                          .rlt_cnslsubscriptionprice_cnslsubscriptionpriceslab[0]
                          .price
                      }}
                      /yr
                    </h4>
                  </div>

                  <!-- Frequency description -->
                  <p
                    v-if="
                      item.rlt_cnslproduct_cnslsubscriptionprice[0].frequency ==
                      'Monthly'
                    "
                    class="ml-4 text-gray-400 text-sm"
                  >
                    Per User / Per Month
                  </p>
                  <p
                    v-if="
                      item.rlt_cnslproduct_cnslsubscriptionprice[0].frequency ==
                      'Yearly'
                    "
                    class="ml-4 text-gray-400 text-sm"
                  >
                    Per User / Per Year
                  </p>

                  <!-- Display if isComSubActive is true -->
                  <div v-if="item.isComSubActive" class="ml-4 text-green-500">
                   Commercial Subscription is Active
                  </div>
                </span>
              </label>

              <button
                @click="goToNext()"
                class="mt-4 bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded w-full"
              >
                Next
                <i class="dx-icon-chevrondoubleright"></i>
              </button>
            </div>

            <!-- right side end -->
          </div>
        </div>
      </section>
    </div>
  </app-layout>
</template>

<script>
import UpgradeProgressstep from "./Components/UpgradeProgressbar.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import DxSelectBox from "devextreme-vue/select-box";

import { DxScrollView } from "devextreme-vue/scroll-view";
import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";

export default {
  props: {
    productData: {
      type: Array,
      default: () => [],
    },
    deployedProductList: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    UpgradeProgressstep,
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxPaging,
    BsOnBoardForm,
    DxScrollView,
    DxSelectBox,
  },
  data() {
    return {
      selectedContent: "Starter",
      selectedPlanId: null,
      selectedProductFamily: null,
      simpleProducts: [],
      title: "Organisations",
      routeDef: "tenant-lists",
      createPopupVisible: false,
      productPopupVisible: false,
      selectedValue: null,
      defaultValue: null,
      displayExpr: null,
      planList: [],
      defaultSelectedValue: null,
      selectedFamilyValue: null,
      slectedProductId: null,
      saveButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.saveRecord,
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.createPopupVisible = false;
        },
      },
    };
  },
  methods: {
    onValueChanged(e) {
      console.log("Onvalue Changed", e);
      const desiredObject = this.productData.find(
        (item) => item.id === e.value
      );
      this.planList = desiredObject.rlt_cnslsubscriptionproduct_cnslproduct;
      if (this.planList.length > 0) {
        this.selectedPlanId = this.planList[0].id;
      }
    },
    goToNext() {
      var data = {
        subscriptionPlanId: this.slectedProductId,
        subscriptionProductId: this.selectedProductFamily,
      };
      console.log("slectedProductId", this.slectedProductId);
      if (this.slectedProductId != null) {
        this.$inertia.post(route("marketplaces.billingaccounts"), data);
      } else {
        alert("Please Select Any Product !!");
      }
    },

    getSelectedData(id) {
      // alert("selected slectedProductId " + id);
      this.slectedProductId = id;
    },
    formatDate(dateString) {
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
  },
  mounted() {
    console.log("productData", this.productData);
    this.selectedPlanId =
      this.productData.rlt_cnslsubscriptionproduct_cnslproduct[0].id;
    this.selectedProductFamily = this.productData.id;
    this.slectedProductId = this.selectedPlanId;
  },
  computed: {},
};
</script>

<style>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}

.mx-5 {
  margin-left: 7rem !important;
  margin-right: 7rem !important;
}

.img-company {
  width: 50px;
  height: 50px;
}

.no-decoration {
  text-decoration: none;
}

.no-decoration:hover {
  text-decoration: none;
}

.organisations-container {
  width: 50% !important;
  background: var(--white);
}

.ul-add-organisation {
  background-color: var(--blue);
}

.btn-submit {
  background-color: var(--blue);
}

/* progress css start here  */

*,
*:after,
*:before {
  box-sizing: border-box;
}

h1 {
  margin-bottom: 1.5em;
}

.steps {
  margin-bottom: 1em;
}

/* progress end here */
/* after steps */
.card {
  background-color: #fff;
  /* padding:20px; */
  border-radius: var(--card-radius);
  position: relative;
}

.card:hover {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15);
}

.radio {
  font-size: inherit;
  margin: 0;
  position: absolute;
  left: calc(var(--card-padding));
  top: calc(var(--card-padding));
}

@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  .radio {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: #fff;
    border: var(--radio-border-width) solid var(--color-gray);
    border-radius: 50%;
    cursor: pointer;
    height: var(--radio-size);
    outline: none;
    transition: background 0.2s ease-out, border-color 0.2s ease-out;
    width: var(--radio-size);
  }

  .radio::after {
    border: var(--radio-border-width) solid #fff;
    border-top: 0;
    border-left: 0;
    content: "";
    display: block;
    height: 0.75rem;
    left: 25%;
    position: absolute;
    top: 50%;
    transform: rotate(45deg) translate(-50%, -50%);
    width: 0.375rem;
  }

  .radio:checked {
    background: var(--color-green);
    border-color: var(--color-green);
  }

  .card:hover .radio {
    border-color: var(--color-dark-gray);
  }

  .card:hover .radio:checked {
    border-color: var(--color-green);
    --tw-ring-color: rgba(27, 243, 167, 0.886);
    background: var(--color-green);
  }
}

[type="radio"] {
  color: var(--color-green);
}

input[type="radio"] {
  --tw-ring-color: rgba(27, 243, 167, 0.886) !important;
}

.plan-details {
  border: var(--radio-border-width) solid var(--color-gray);
  border-radius: var(--card-radius);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: var(--cards-padding);
  transition: border-color 0.2s ease-out;
}

.card:hover .plan-details {
  border-color: var(--color-dark-gray);
}

.radio:checked ~ .plan-details {
  border-color: var(--color-green);
}

.radio:focus ~ .plan-details {
  box-shadow: 0 0 0 2px var(--color-dark-gray);
}

.radio:disabled ~ .plan-details {
  color: var(--color-dark-gray);
  cursor: default;
}

.card:hover .radio:disabled ~ .plan-details {
  border-color: var(--color-gray);
  box-shadow: none;
}

.card:hover .radio:disabled {
  border-color: var(--color-gray);
}

:root {
  --card-line-height: 1.2em;
  --card-padding: 0.7em;
  --cards-padding: 1.3em;
  --card-radius: 0.3em;
  --color-green: #0ecb8f;
  --color-gray: #e2ebf6;
  --color-dark-gray: #c4d1e1;
  --radio-border-width: 2px;
  --radio-size: 1.3em;
}

h4 {
  margin-bottom: 0rem;
  /* font-weight: 500; */
  line-height: 1.2;
}

p {
  margin-bottom: -3px;
}

/* button start */
.dx-icon-edit {
  font: 20px/1 DXIcons;
}

.dx-dropdownlist-popup-wrapper
  .dx-list:not(.dx-list-select-decorator-enabled)
  .dx-list-item-content {
  padding: 8px;
  font-size: larger;
}

/* input::placeholder, textarea::placeholder {
  color: #6b7280;
  opacity: 1;
  font: 60px !important;
} */

.Plan_Card {
  margin-top: 7.7rem;
}
</style>